/** @jsx jsx */
import { jsx } from "theme-ui"

const Container = ({ variant = "container", ...props }) => {
  return <div sx={{ variant: `layout.${variant}` }} {...props}></div>
}

export default Container
